import React, {useContext} from "react";

// Data shared by every page under /registry-project/:registryProjectId
// project: ProjectDTO, members: ProjectMemberDTO[], role: the current user's project role,
// subProject / basePath: the selected sub project (set once the :subProjectId route resolves)
// changeSubProject(id): opens the same page for another sub project (see SubProjectSelect)
export const RegistryProjectContext = React.createContext({
  project: null,
  members: [],
  role: null,
  isAnnotator: false,
  subProject: null,
  basePath: "",
  changeSubProject: () => {},
  refreshProject: () => Promise.resolve(),
});

export const useRegistryProject = () => useContext(RegistryProjectContext);
